import React, { useEffect, useState } from 'react';
import { Chip, Autocomplete, TextField } from '@mui/material';
import CachedIcon from '@mui/icons-material/Cached';

export const SelectOrderCategoryAutocomplete = ({ context, selectedOrderCategory, setSelectedOrderCategory }) => {
    const [orderCategories, setOrderCategories] = useState([]);
    const [isOrderCategorySelected, setIsOrderCategorySelected] = useState(true);

    useEffect(() => {
        const getOrderCategory = context.get('Get Order Category');

        const [triggerInputCategory] = getOrderCategory.getInputs();

        // eslint-disable-next-line no-unused-vars
        const [SuccessCategory, ErrorCategory, arrayCategory] = getOrderCategory.getOutputs();

        const getOrderCategory$ = context.runner(getOrderCategory).trigger(triggerInputCategory);

        getOrderCategory$.waitFor(SuccessCategory).then(() => {
            setOrderCategories(getOrderCategory$.get(arrayCategory));
            setSelectedOrderCategory(getOrderCategory$.get(arrayCategory)[0]);
        });
    }, []);

    if (selectedOrderCategory && isOrderCategorySelected === true) {
        return (
            <Chip
                label={`${selectedOrderCategory.Auftyp} - ${selectedOrderCategory.Descr}`}
                color="primary"
                icon={<CachedIcon />}
                sx={{ marginBottom: '1vh' }}
                onClick={() => setIsOrderCategorySelected(false)}
            />
        );
    } else if (isOrderCategorySelected === false) {
        return (
            <Autocomplete
                value={selectedOrderCategory}
                onChange={(event, newValue) => {
                    setSelectedOrderCategory(newValue);
                    setIsOrderCategorySelected(true);
                }}
                loadingText="...Loading"
                options={orderCategories}
                disableClearable={true}
                getOptionLabel={(params) => {
                    if (params) {
                        return params.Auftyp ? `${params.Auftyp} - ${params.Descr}` : params.Descr;
                    }
                }}
                size={'small'}
                renderInput={(params) => <TextField {...params} variant="standard" />}
            />
        );
    } else {
        return null;
    }
};
